<script setup lang="ts">
import { useSearchStore } from '@stores/useSearchStore.ts';
import { storeToRefs } from 'pinia';

const { mapIsVisible } = storeToRefs(useSearchStore());
</script>

<template>
  <div
    :class="[
      'grid',
      mapIsVisible ? 'grid-cols-1 lg:grid-cols-2' : 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3',
      'gap-6',
      'py-4',
    ]"
  >
    <div
      v-for="n in 6"
      :key="n"
      :class="[
        'relative',
        'overflow-hidden',
        'rounded-lg',
        'bg-gray-lighter',
        'min-w-[250px]',
      ]"
    >
      <div
        :class="[
          'absolute',
          'left-0 top-0',
          'size-full',
          'animate-shimmer',
          'bg-gradient-to-r from-transparent via-white/60 to-transparent',
        ]"
      />

      <div
        :class="[
          'w-full',
          'h-[200px]',
          'bg-gray-light',
        ]"
      />

      <div class="p-4">
        <div
          :class="[
            'rounded',
            'mb-3',
            'h-5 w-[70%]',
            'bg-gray-light',
          ]"
        />

        <div
          :class="[
            'rounded',
            'mb-3',
            'h-4 w-full',
            'bg-gray-light',
          ]"
        />

        <div
          :class="[
            'rounded',
            'h-4 w-3/5',
            'bg-gray-light',
          ]"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(100%);
  }
}

.animate-shimmer {
  animation: shimmer 1.5s infinite;
}
</style>
